<template>
  <div class="kjfixed">
    <div class="fixed-list">
      <a @click.prevent class="item">
        <div class="pics">
          <img src="~@/assets/images/d_fix_pic_01_show.png" class="show">
          <img src="~@/assets/images/d_fix_pic_01.png" class="hide">
        </div>
        <div class="name">关注科橘</div>
      </a>
    </div>
    <div class="info">
      <div class="box">
        <img src="~@/assets/images/qr.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KJ'
}
</script>

<style scoped>
.kjfixed{
  top: 40%;
  position: fixed;
  right: 13px;
  z-index: 9800;
}
.kjfixed .fixed-list{
  border-radius: 40px;
  margin-bottom: 14px;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, .1);
}
.item{
  padding-left: 6px;
  padding-right: 6px;
  width: 30px;
  padding-top: 15px;
  padding-bottom: 16px;
  background: #fff;
  border-radius: 40px;
  border: 2px solid #fff;
  transition: all 0.36s;
  display: block;
}
.item:hover{
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, .1);
  background-color: #fe7108;
}
.item:hover .name{
  color: #fff;
}
.pics{
  width: 17px;
  position: relative;
}
.pics img{
  z-index: 1;
  opacity: 1;
  transition: all 0.36s;
}
.item .pics .show{
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.item:hover .pics .hide{
  opacity: 0;
}
.item:hover .pics .show{
  opacity: 1;
}
.name{
  font-size: 14px;
  color: #ffa000;
  line-height: 16px;
  margin-top: 4px;
  transition: all 0.36s;
  word-wrap: break-word;
  word-break: normal;
}
.info{
  position: absolute;
  top: 0;
  width: 130px;
  right: 40px;
  top: 0;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, .1);
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  transition: all 0.3s;
  transition-delay: 0.1s;
  opacity: 0;
  display: none;
}
.kjfixed:hover .info{
  display: block;
  opacity: 1;
  right: 50px;
}
.info::before{
  content: '';
  width: 12px;
  height: 12px;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, .1);
  border-right: 1px solid rgba(0, 0, 0, .1);
  position: absolute;
  top: 38px;
  right: -10px;
  z-index: 2;
  display: block;
  transform: rotate(46deg) translateX(-50%);
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .kjfixed .item{
    width: 40px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .kjfixed .name{
    font-size: 16px;
    line-height: 18px;
    margin-top: 7px;
  }
  .kjfixed:hover .info{
    right: 60px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/KJ.vue